"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeApiClient = makeApiClient;
const util_1 = require("@clh/util");
const fetch_1 = require("./fetch");
function makeApiClient(opts) {
    const { accessToken, basePath, fetchApi, middleware = [] } = opts;
    return new fetch_1.DefaultApi(new fetch_1.Configuration({
        basePath,
        fetchApi,
        accessToken,
        middleware: [
            new util_1.apiMiddleware.ErrorHandlerMiddleware(),
            ...middleware,
        ],
    }));
}
//# sourceMappingURL=make-api-client.js.map